import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { ApiMananger } from "actions/rtkquery";
import { selectToken } from "redux/features/userSliceWithTokenValidation";
import api from "routes/api/global-vars";

export const customFetchBaseQuery = () => {
    return fetchBaseQuery({
        baseUrl: api,
        prepareHeaders: (headers, { getState }) => {
          const token = selectToken(getState());
          if (token) {
            headers.set("Authorization", `Bearer ${token}`);
          }
          headers.set("Content-Type", "application/json");
          return headers;
        },
    });
  };

const userApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({
        getUser: build.query({
            query: () => "API.USER_API.GET_USER()",
        }),
        emailVerification: build.query({
            query: (token) => "API.USER_API.VERIFICATION_EMAIL(token)",
        }),
    }),
});

export const {
    useGetUserQuery,
    useEmailVerificationQuery,
} = userApi;